// The file-request questions, as a reusable block of controlled fields — used
// inline by NewListingLeadModal's "Also Request a File" section and inside
// FileRequestDetailsDialog for the lead drawers. Same field codes as the full
// Listing Request form (main-list-request.jsx) and the request email
// (utils/listingRequestEmail.js), so an answer given here reads identically
// everywhere downstream.
//
// Everything is OPTIONAL: an agent in a hurry can still just request the file.
// Whatever they answer lands on the file; blanks stay blank for the team.

export const FILE_FORMAT_OPTIONS = [
  "Full Physical",
  "Full Digital",
  "Part Physical & Digital",
];

const DISCLOSURE_OPTIONS = [
  { value: "seller_disclosure", label: "Sellers Disclosure" },
  { value: "seller_disclosure_alternative", label: "Sellers Disclosure Alternative" },
  {
    value: "seller_disclosure_alternative_as_is",
    label: "Sellers Disclosure Alternative with AS-IS",
  },
];

const label = "block text-xs font-semibold text-slate-500 mb-1";
const field =
  "w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-slate-500";

function YesNo({ name, value, onChange }) {
  return (
    <div className="flex items-center gap-4">
      {["yes", "no"].map((v) => (
        <label key={v} className="flex items-center gap-1.5 text-sm cursor-pointer">
          <input
            type="radio"
            name={name}
            checked={value === v}
            onChange={() => onChange(v)}
          />
          {v === "yes" ? "Yes" : "No"}
        </label>
      ))}
    </div>
  );
}

export default function FileRequestDetailsFields({
  side = "seller",
  value = {},
  onChange,
}) {
  const set = (key) => (v) => onChange?.({ ...value, [key]: v });
  const setEvt = (key) => (e) => onChange?.({ ...value, [key]: e.target.value });

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className={label}>Need File By</label>
          <input
            type="date"
            className={field}
            value={value.fileDeadline || ""}
            onChange={setEvt("fileDeadline")}
          />
        </div>
        {side === "seller" && (
          <div>
            <label className={label}>Listing Appointment</label>
            <input
              type="date"
              className={field}
              value={value.listingDate || ""}
              onChange={setEvt("listingDate")}
            />
          </div>
        )}
      </div>

      <div>
        <label className={label}>File Format</label>
        <div className="flex flex-wrap gap-x-4 gap-y-1">
          {FILE_FORMAT_OPTIONS.map((option) => (
            <label
              key={option}
              className="flex items-center gap-1.5 text-sm cursor-pointer"
            >
              <input
                type="radio"
                name="frd-fileFormat"
                checked={value.fileFormat === option}
                onChange={() => set("fileFormat")(option)}
              />
              {option}
            </label>
          ))}
        </div>
      </div>

      {side === "seller" && (
        <>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className={label}>Commission %</label>
              <input
                type="number"
                step="0.1"
                min="0"
                className={field}
                value={value.totalcommissionrate || ""}
                onChange={setEvt("totalcommissionrate")}
              />
            </div>
            <div>
              <label className={label}>Seller's Disclosure</label>
              <select
                className={field}
                value={value.sellerDisclosure || ""}
                onChange={setEvt("sellerDisclosure")}
              >
                <option value="">Choose…</option>
                {DISCLOSURE_OPTIONS.map((o) => (
                  <option key={o.value} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className={label}>Property in a Trust?</label>
              <YesNo
                name="frd-propertyTrust"
                value={value.propertyTrust || ""}
                onChange={set("propertyTrust")}
              />
            </div>
            <div>
              <label className={label}>Photo Book?</label>
              <YesNo
                name="frd-photoBook"
                value={value.photoBook || ""}
                onChange={set("photoBook")}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className={label}>Pre-Listing Drop-Off?</label>
              <YesNo
                name="frd-preListing"
                value={value.preListing || ""}
                onChange={set("preListing")}
              />
            </div>
            {value.preListing === "yes" && (
              <div>
                <label className={label}>Drop-Off By</label>
                <input
                  type="date"
                  className={field}
                  value={value.dropOff || ""}
                  onChange={setEvt("dropOff")}
                />
              </div>
            )}
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className={label}>Client Referral?</label>
              <YesNo
                name="frd-clientReferal"
                value={value.clientReferal || ""}
                onChange={set("clientReferal")}
              />
            </div>
            {value.clientReferal === "yes" && (
              <div>
                <label className={label}>Referred By (Send Gift)</label>
                <input
                  type="text"
                  className={field}
                  value={value.referredSendGift || ""}
                  onChange={setEvt("referredSendGift")}
                />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
